import React, { useEffect, useState } from 'react';
import {
    Form,
    Button,
    Spinner,
    Offcanvas,
    Stack,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useAssignTestToDocMutation } from './eyetestApi';
import { useDoctorListMutation } from '../Doctor/doctorApi';
import { useLocation } from 'react-router';

const AssignDoc = ({ idSum, setLoading,onClearSelection, setAssignmentCompleted }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(true);
    const [list, setList] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState('');
    const { state } = useLocation();

    const handleClose = () => setShow(false);
    const toggleShow = () => setShow((s) => !s);

    const [assignTest] = useAssignTestToDocMutation();
    const [doctorListMutation] = useDoctorListMutation();

    useEffect(() => {
        (async () => {
            if (show) {
                let { data } = await doctorListMutation({
                    email: '',
                    mobile: '',
                });
                setList(data);
                setModalLoading(false);
            }
        })();
    }, [show]);

    const handleSubmit = async () => {
        setButtonLoading(true);
        let { data } = await assignTest({
            doctorEmail: selectedDoc,
            tests: idSum,
        });
        if (data) {
            setButtonLoading(false);
            setShow(false);
            setLoading(true);
            // Safe call with optional chaining
            setAssignmentCompleted?.(true);
            onClearSelection?.();
        }
    };

    return (
        <>
            {!state.edit && (
                <Button
                    variant="primary"
                    onClick={toggleShow}
                    disabled={idSum.length === 0}
                >
                    {t('attribuer')}
                </Button>
            )}
            <Offcanvas
                show={show}
                onHide={handleClose}
                backdrop="static"
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{t('medecin')}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {modalLoading ? (
                        <Stack gap={2} className="mx-auto">
                            <Spinner
                                className="mx-auto"
                                animation="border"
                                role="status"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        </Stack>
                    ) : (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('affecterUnMedecin')}
                                </Form.Label>
                                <Form.Select
                                    aria-label="Default"
                                    value={selectedDoc}
                                    onChange={(e) =>
                                        setSelectedDoc(e.target.value)
                                    }
                                >
                                    <option disabled value={''}>
                                        {t('selectItem')}
                                    </option>
                                    {list.map((item, index) => (
                                        <option key={index} value={item.email}>
                                            {item.email}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <Stack
                                direction="horizontal"
                                gap={3}
                                className="mb-3"
                            >
                                <Button
                                    variant="primary"
                                    onClick={handleSubmit}
                                    disabled={!selectedDoc}
                                >
                                    {buttonLoading && (
                                        <Spinner
                                            animation="border"
                                            role="status"
                                            size="sm"
                                        >
                                            <span className="visually-hidden">
                                                Loading...
                                            </span>
                                        </Spinner>
                                    )}{' '}
                                    {t('attribuer')}
                                </Button>
                            </Stack>
                        </>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

AssignDoc.propTypes = {
    idSum: PropTypes.array.isRequired,
    setLoading: PropTypes.func.isRequired,
    setAssignmentCompleted: PropTypes.func
};

AssignDoc.defaultProps = {
    setAssignmentCompleted: () => { }
};

export default AssignDoc;